import Vue from 'vue';
import VeeValidate from 'vee-validate';
import PhoneNumber from 'awesome-phonenumber';

Vue.use(VeeValidate, {
  inject: false
});

const phoneNumber = {
  getMessage: (_field) => 'The phone number is not valid',
  validate(value) {
    return new Promise((resolve) => {
      let phone = new PhoneNumber(value, 'AU');
      resolve({ valid: phone.isValid() });
    });
  }
};
VeeValidate.Validator.extend('phoneNumber', phoneNumber);
